/*
 * File: modal.ts
 * File Created: 2023-12-05 02:58:18
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified:
 * Modified By:
 * -----
 */

import { Vue } from "vue-property-decorator";

declare module "vue/types/vue" {
    export interface Vue {
        $modal(): void;
    }
}

export const ModalPlugin = {
    install: function (Vue: any) {
        if (Vue._val_modal_installed) return;
        Vue._val_modal_installed = true;

        Vue.mixin({
            methods: {
                /// control the modal popup
                $modal: function (this: Vue): Vue {
                    let component = this.$mount();
                    let body =
                        document.getElementById("app") ||
                        document.getElementsByTagName("body")[0];
                    body.appendChild(component.$el);
                    component.$set(component.$props, "visible", true);
                    component.$on("update:visible", (newvalue, oldvalue) => {
                        if (!newvalue && component) {
                            setTimeout(() => {
                                component.$el.parentNode &&
                                    body.removeChild(component.$el);
                                component.$destroy();
                            }, 1000);
                        }
                    });
                    return this;
                },
            },
        });
    },
};
